import VGMask from "../../../vendor/vegas/mask/mask";

window.VegasListener = {
	onReady: () => {
		Vegas.bg();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.inputFiles();
		Vegas.tariffs();
		Vegas.fixedScrollTo($(window));
		Vegas.fixedScrollHeader($(window));
	},

	onLoad: () => {
		Vegas.preloader();
	},

	onClick: () => {
		Vegas.popup();
	},

	onScroll: ($self) => {
		Vegas.fixedScrollTo($self);
		Vegas.fixedScrollHeader($self);
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization", "color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	preloader: function () {

	},

	enablePlugins: function () {
		//owl
		OwlVegas.init('owl-carousel');

		VGMask.init();

		// vegas nav
		$('.vg-nav').vegasMenu();
	},

	popup: function () {
		$('[data-modal]').click(function () {
			let $target = $(this).data('modal'),
				id = $(this).data('id') || false,
				title = $(this).data('title') || false;

			if (title) {
				$($target).find('.modal-title').text(title);
			}

			if (id) {
				$($target).find('form input[name=id]').val(id);
			}

			$($target).modal('show');

			return false;
		});
	},

	bg: function () {
		let $bg = $('[data-bg]');
		if ($bg.length) {
			$bg.each(function () {
				let $self = $(this),
					bg = $self.data('bg'),
					repeat = $self.data('repeat') || 'no-repeat',
					position = $self.data('position') || 'center',
					size = $self.data('size') || 'cover',
					attachment = $self.data('attachment') || 'inherit';

				$self.css({
					'background-image': 'url(' + bg + ')',
					'background-position': position,
					'background-repeat': repeat,
					'background-size': size,
					'background-attachment': attachment
				});
			});
		}
	},

	other: function () {
		// default page
		let $pageText = $('.vg-page-default'),
			$table = $pageText.find('table');
		$table.addClass('table table-hover table-striped');
		$table.wrap('<div class="table-responsive"></div>');
		$pageText.find('br').after('<span class="mb-15 d-block"></span>');
		$pageText.find('img').addClass('img-fluid');

		let $prd_thumb_carousel = $('.thumbs-carousel');
		if ($prd_thumb_carousel.length) {
			$prd_thumb_carousel.slick({
				slidesToShow: 6,
				slidesToScroll: 1,
				vertical: true,
				verticalSwiping: true,
				dots: false,
				autoplay: false,
				autoplaySpeed: 5000,
				speed: 1000,
				arrows: true,
				infinite: false,
				responsive: [
					{
						breakpoint: 600,
						settings: {
							arrows: false,
							vertical: false,
							verticalSwiping: false,
							slidesToShow: 4,
							slidesToScroll: 1
						}
					}
				]
			});
		}
	},

	inputFiles: function () {
		$('[type=file]').change(function () {
			let $self = $(this),
				$label = $self.closest('.form-group').find('label');

			if (this.value) {
				$label.removeClass('error');
				$self.closest('.form-group').find('p').hide();

				$label.find('i').removeClass('fa-file-plus').addClass('fa-file-check');
				$label.addClass('success');
			} else {
				$label.addClass('error');
				$self.after('<p class="error">Вы не выбрали файл</p>');
				$label.find('i').removeClass('file-check').addClass('fa-file-file-plus');
				$label.removeClass('success');
			}

			return false;
		});
	},

	tariffs: function () {
		$('[data-to-type]').click(function () {
			let type = $(this).data('to-type'),
				$elem = $('section.tariffs [data-type="' + type + '"]').first();

			$([document.documentElement, document.body]).animate({
				scrollTop: $elem.offset().top - 220
			}, 1000);

			$elem.find('a').trigger('click').click();

			return false;
		});

		let $modalTariff = $("#modal-tariff");

		$('[data-modal="#modal-tariff"]').click(function () {
			let id = $(this).data('id'),
				$option = $modalTariff.find('[name=user_tariff] option[value="' + id + '"]');

			$option.attr('selected', true);

			let type = $option.data('type');
			let $userForm = $modalTariff.find('[name=user_form]');
			$userForm.find('option').removeAttr('selected');
			$userForm.find('option[value="' + type + '"]').attr('selected', true);
		});

		$modalTariff.find('[name=user_form]').change(function () {
			let type = $(this).val();

			let $tariffs = $("[name=user_tariff]");
			let $tariffsOptions = $tariffs.find('option');

			let selected = 0;

			$tariffsOptions.each(function (i, e) {
				if ($(e).data('type') === type) {
					if (!selected) {
						selected = $(e).attr('value');
					}

					$(e).removeClass('d-none');
				} else {
					$(e).addClass('d-none');
				}

				$(e).removeAttr('selected');
			});

			let $selectOption = $tariffs.find('option[value=' + selected + ']').first();
			$selectOption.attr('selected', true);

		}).trigger('change');
	},

	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();

		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}

		return false;
	},

	fixedScrollHeader: function ($self) {
		let $sticky = $('header'),
			scroll = $self.scrollTop();

		if (scroll > 120) {
			$sticky.addClass('fixed');
		} else {
			$sticky.removeClass('fixed');
		}

		return false;
	}
};
